import { render, staticRenderFns } from "./publishManageBar.vue?vue&type=template&id=3698af8e&scoped=true&"
import script from "./publishManageBar.vue?vue&type=script&lang=js&"
export * from "./publishManageBar.vue?vue&type=script&lang=js&"
import style0 from "./publishManageBar.vue?vue&type=style&index=0&id=3698af8e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3698af8e",
  null
  
)

export default component.exports